export const MODULE_NAME = 'axp-travel-search-date-picker';
